import React, { useEffect, useRef, useState } from "react";
import { useOutletContext } from "react-router-dom";
import $ from "jquery";
import axios from "axios";
import { useDropzone } from "react-dropzone";
import ReactMarkdown from "react-markdown";

window.$ = $;
window.jQuery = $;
require("jquery-slimscroll");

function AskPine() {
  const { token } = useOutletContext();

  const [messages, setMessages] = useState([]);
  const [input, setInput] = useState("");
  const [fileText, setFileText] = useState("");
  const [wait, setWait] = useState(false);
  const [sessionId, setSessionId] = useState(null);
  const [sessions, setSessions] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");

  const filteredSessions = sessions.filter((s) =>
    (s.first_message || "").toLowerCase().includes(searchQuery.toLowerCase()),
  );

  const REACT_APP_API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
  const base_url = process.env.REACT_APP_BASE_URL;

  const user = JSON.parse(localStorage.getItem("user") || "{}");
  const bottomRef = useRef(null);

  /* ---------------- MIC ---------------- */
  const startListening = () => {
    const SpeechRecognition =
      window.SpeechRecognition || window.webkitSpeechRecognition;
    if (!SpeechRecognition) return;
    const recognition = new SpeechRecognition();
    recognition.lang = "en-US";
    recognition.onresult = (event) => {
      setInput(event.results[0][0].transcript);
    };
    recognition.start();
  };

  /* ---------------- FETCH ALL SESSIONS (from DB) ---------------- */
  const fetchSessions = async () => {
    try {
      const res = await axios.get(
        `${REACT_APP_API_BASE_URL}/chatgpt/get_sessions`,
        {
          params: { user_id: user.id },
          headers: { Authorization: `Bearer ${token}` },
        },
      );
      setSessions(res.data || []);
    } catch (err) {
      console.error("Fetch sessions error:", err);
    }
  };

  /* ---------------- CREATE SESSION ---------------- */
  const createSession = async () => {
    try {
      const res = await axios.post(
        `${REACT_APP_API_BASE_URL}/chatgpt/create_session`,
        { user_id: user.id },
        { headers: { Authorization: `Bearer ${token}` } },
      );
      const newSessionId = res.data.session_id;
      setSessionId(newSessionId);
      setMessages([]);
      // Refresh sidebar so the new session appears
      await fetchSessions();
    } catch (err) {
      console.error("Session error:", err);
    }
  };

  /* ---------------- FETCH MESSAGES ---------------- */
  const fetchMessages = async (sid) => {
    try {
      const res = await axios.post(
        `${REACT_APP_API_BASE_URL}/chatgpt/get_messages`,
        { session_id: sid, user_id: user.id }, // ← add user_id
        { headers: { Authorization: `Bearer ${token}` } },
      );
      setMessages(res.data || []);
      setSessionId(sid);
    } catch (err) {
      console.error("Fetch messages error:", err);
    }
  };

  /* ---------------- SEND MESSAGE ---------------- */
  const sendMessage = async (e) => {
    e.preventDefault();
    if (!input.trim() || !sessionId) return;

    const userMessage = { role: "user", content: input.trim() };
    const updatedMessages = [...messages, userMessage];
    setMessages(updatedMessages);
    setInput("");

    try {
      setWait(true);
      const res = await axios.post(
        `${REACT_APP_API_BASE_URL}/chatgpt/pine_chat`,
        { message: userMessage.content, session_id: sessionId },
        { headers: { Authorization: `Bearer ${token}` } },
      );
      const assistantMessage = { role: "assistant", content: res.data.reply };
      setMessages([...updatedMessages, assistantMessage]);
      setFileText("");
    } catch (err) {
      console.error("Chat Error:", err);
    } finally {
      setWait(false);
    }
  };

  /* ---------------- FILE UPLOAD ---------------- */
  const onDrop = (acceptedFiles) => {
    const file = acceptedFiles[0];
    if (!file) return;
    const reader = new FileReader();
    reader.onload = () => setFileText(reader.result);
    reader.readAsText(file);
  };
  const { getRootProps, getInputProps } = useDropzone({ onDrop });

  /* ---------------- INIT: load sessions, then start a new chat ---------------- */
  useEffect(() => {
    const init = async () => {
      await fetchSessions();
      await createSession();
    };
    init();
  }, []);

  /* ---------------- SLIMSCROLL ---------------- */
  useEffect(() => {
    $(".slimscroll").slimScroll({
      height: "300px",
      size: "8px",
      color: "#888",
      alwaysVisible: false,
      railVisible: true,
    });
    return () => $(".slimscroll").slimScroll({ destroy: true });
  }, []);

  /* ---------------- AUTO SCROLL ---------------- */
  useEffect(() => {
    bottomRef.current?.scrollIntoView({ behavior: "smooth" });
  }, [messages, wait]);

  return (
    <>
      <style>
        {`
        [data-layout="modern"] .mini-sidebar .slimScrollDiv {
        height: calc(100% - 20px) !important;
          }

        .slimscroll {
        height: 400px !important;
        }
        `}
      </style>
      <div className="content d-flex">
        {/* Sidebar */}
        <div className="chat-sidebar me-3" style={{ width: "300px" }}>
          <div>
            {/* Sidebar */}
            <div
              className="chat-sidebar me-3"
              style={{ width: "300px", borderRight: "1px solid #eee" }}
            >
              <div className="chat-search-header p-3">
                <div className="d-flex align-items-center justify-content-between mb-3">
                  <h4 className="mb-0">Chats</h4>
                  <button
                    className="btn btn-sm btn-primary"
                    onClick={createSession}
                  >
                    + New Chat
                  </button>
                </div>
                <div className="input-group">
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Search chats..."
                    value={searchQuery}
                    onChange={(e) => setSearchQuery(e.target.value)}
                  />
                  <span className="input-group-text">
                    <i className="ti ti-search"></i>
                  </span>
                </div>
              </div>
              <div
                className="slimscroll"
                style={{ overflow: "hidden", height: "100%" }}
              >
                <div className="sidebar-body" style={{ overflowY: "auto" }}>
                  {sessions.length === 0 ? (
                    <div className="text-center text-muted p-4">
                      <i className="ti ti-message-off fs-1"></i>
                      <p className="mt-2">No chats yet</p>
                    </div>
                  ) : (
                    filteredSessions.map((s) => (
                      <div
                        key={s.session_id}
                        onClick={() => fetchMessages(s.session_id)}
                        className={`d-flex align-items-start p-3 border-bottom ${
                          sessionId === s.session_id
                            ? "bg-primary bg-opacity-10"
                            : ""
                        }`}
                        style={{
                          cursor: "pointer",
                          transition: "background 0.2s",
                        }}
                        onMouseEnter={(e) => {
                          if (sessionId !== s.session_id)
                            e.currentTarget.style.background = "#f8f9fa";
                        }}
                        onMouseLeave={(e) => {
                          if (sessionId !== s.session_id)
                            e.currentTarget.style.background = "";
                        }}
                      >
                        {/* Avatar */}
                        <div className="avatar avatar-md me-3 flex-shrink-0">
                          <div
                            className="rounded-circle d-flex align-items-center justify-content-center bg-primary text-white"
                            style={{ width: 40, height: 40, fontSize: 16 }}
                          >
                            <i className="ti ti-robot"></i>
                          </div>
                        </div>

                        {/* Info */}
                        <div className="flex-grow-1 overflow-hidden">
                          <div className="d-flex justify-content-between align-items-center">
                            {/* First message as title */}
                            <h6
                              className="mb-0 text-truncate"
                              style={{ maxWidth: "160px", fontSize: "13px" }}
                            >
                              {s.first_message
                                ? s.first_message.substring(0, 28) +
                                  (s.first_message.length > 28 ? "..." : "")
                                : `Chat #${s.session_id}`}
                            </h6>
                            {/* Last active time */}
                            <small
                              className="text-muted flex-shrink-0 ms-1"
                              style={{ fontSize: "11px" }}
                            >
                              {s.last_active
                                ? new Date(s.last_active).toLocaleDateString(
                                    "en-IN",
                                    {
                                      day: "2-digit",
                                      month: "short",
                                    },
                                  )
                                : ""}
                            </small>
                          </div>
                          {/* Last message preview */}
                          <p
                            className="mb-0 text-muted text-truncate"
                            style={{ fontSize: "12px" }}
                          >
                            {s.last_message
                              ? s.last_message.substring(0, 35) +
                                (s.last_message.length > 35 ? "..." : "")
                              : "No messages yet"}
                          </p>
                        </div>

                        {/* Active indicator */}
                        {sessionId === s.session_id && (
                          <div className="flex-shrink-0 ms-2">
                            <span
                              className="badge bg-primary rounded-circle"
                              style={{
                                width: 8,
                                height: 8,
                                display: "inline-block",
                              }}
                            ></span>
                          </div>
                        )}
                      </div>
                    ))
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Main chat area */}
        <div className="chat-wrapper flex-grow-1">
          <div className="chat chat-messages show" id="middle">
            <div className="chat-header" style={{ height: "auto" }}>
              <div className="user-details">
                <div className="avatar avatar-lg online flex-shrink-0">
                  <img
                    src={`${base_url}assets/img/profiles/${user.userpic}`}
                    className="rounded-circle"
                    alt="user"
                  />
                </div>
                <div className="ms-2 overflow-hidden">
                  <h6>{`${user.firstname} ${user.lastname}`}</h6>
                  <span className="last-seen">Online</span>
                </div>
              </div>
            </div>

            <div className="chat-body chat-page-group slimscroll">
              <div className="messages">
                {messages.map((msg, idx) => (
                  <React.Fragment key={idx}>
                    {msg.role === "user" ? (
                      <div className="chats chats-right">
                        <div className="chat-content">
                          <div className="chat-info">
                            <div className="message-content">{msg.content}</div>
                          </div>
                          <div className="chat-profile-name text-end">
                            <h6>
                              You
                              <i className="ti ti-circle-filled fs-7 mx-2"></i>
                            </h6>
                          </div>
                        </div>
                        <div className="chat-avatar">
                          <img
                            src={`${base_url}assets/img/profiles/${user.userpic}`}
                            className="rounded-circle"
                            alt="user"
                          />
                        </div>
                      </div>
                    ) : (
                      <div className="chats">
                        <div className="chat-avatar">
                          <img
                            src={`${base_url}/favicon.ico`}
                            className="rounded-circle"
                            alt="PINE"
                            style={{ width: "30px", height: "30px" }}
                          />
                        </div>
                        <div className="chat-content">
                          <div className="chat-info">
                            <div className="message-content">
                              <ReactMarkdown>{msg.content}</ReactMarkdown>
                            </div>
                          </div>
                          <div className="chat-profile-name">
                            <h6>
                              PINE
                              <i className="ti ti-circle-filled fs-7 mx-2"></i>
                            </h6>
                          </div>
                        </div>
                      </div>
                    )}
                  </React.Fragment>
                ))}

                {wait && (
                  <div className="chats">
                    <div className="chat-avatar">
                      <img
                        src={`${base_url}assets/img/profiles/${user.userpic}`}
                        className="rounded-circle"
                        alt="PINE"
                      />
                    </div>
                    <div className="chat-content">
                      <div className="chat-info">
                        <div className="message-content">
                          <span className="animate-typing">
                            is typing
                            <span className="dot"></span>
                            <span className="dot"></span>
                            <span className="dot"></span>
                          </span>
                        </div>
                      </div>
                      <div className="chat-profile-name">
                        <h6>PINE</h6>
                      </div>
                    </div>
                  </div>
                )}

                <div ref={bottomRef}></div>
              </div>
            </div>

            <div className="chat-footer">
              <form onSubmit={sendMessage} className="footer-form">
                <div className="chat-footer-wrap">
                  <div className="form-item">
                    <a
                      onClick={startListening}
                      className="action-circle"
                      disabled={!sessionId}
                    >
                      <i className="ti ti-microphone"></i>
                    </a>
                  </div>

                  <div className="form-wrap">
                    <input
                      value={input}
                      onChange={(e) => setInput(e.target.value)}
                      type="text"
                      className="form-control"
                      placeholder="Type Your Message"
                      disabled={!sessionId}
                    />
                  </div>

                  {/* <div className="form-item emoj-action-foot">
                  <a href="#" className="action-circle">
                    <i className="ti ti-mood-smile"></i>
                  </a>
                  <div className="emoj-group-list-foot down-emoji-circle">
                    <ul>
                      <li>
                        <a href="javascript:void(0);">
                          <img
                            src="assets/img/icons/emonji-02.svg"
                            alt="Icon"
                          />
                        </a>
                      </li>
                      <li>
                        <a href="javascript:void(0);">
                          <img
                            src="assets/img/icons/emonji-05.svg"
                            alt="Icon"
                          />
                        </a>
                      </li>
                      <li>
                        <a href="javascript:void(0);">
                          <img
                            src="assets/img/icons/emonji-06.svg"
                            alt="Icon"
                          />
                        </a>
                      </li>
                      <li>
                        <a href="javascript:void(0);">
                          <img
                            src="assets/img/icons/emonji-07.svg"
                            alt="Icon"
                          />
                        </a>
                      </li>
                      <li>
                        <a href="javascript:void(0);">
                          <img
                            src="assets/img/icons/emonji-08.svg"
                            alt="Icon"
                          />
                        </a>
                      </li>
                      <li className="add-emoj">
                        <a href="javascript:void(0);">
                          <i className="ti ti-plus"></i>
                        </a>
                      </li>
                    </ul>
                  </div>
                </div> */}

                  {/* <div
                  {...getRootProps()}
                  className="form-item position-relative d-flex align-items-center justify-content-center"
                >
                  <a
                    href="#"
                    className="action-circle file-action position-absolute"
                  >
                    <i className="ti ti-folder"></i>
                  </a>
                  <input
                    {...getInputProps()}
                    className="open-file position-relative"
                  />
                </div> */}

                  {/* <div className="form-item">
                  <a href="#" data-bs-toggle="dropdown">
                    <i className="ti ti-dots-vertical"></i>
                  </a>
                  <div className="dropdown-menu dropdown-menu-end p-3">
                    <a href="#" className="dropdown-item">
                      <i className="ti ti-camera-selfie me-2"></i>Camera
                    </a>
                    <a href="#" className="dropdown-item">
                      <i className="ti ti-photo-up me-2"></i>Gallery
                    </a>
                    <a href="#" className="dropdown-item">
                      <i className="ti ti-music me-2"></i>Audio
                    </a>
                    <a href="#" className="dropdown-item">
                      <i className="ti ti-map-pin-share me-2"></i>Location
                    </a>
                    <a href="#" className="dropdown-item">
                      <i className="ti ti-user-check me-2"></i>Contact
                    </a>
                  </div>
                </div> */}

                  <div className="form-btn">
                    <button
                      className="btn btn-primary"
                      type="submit"
                      disabled={wait || !sessionId}
                    >
                      <i className="ti ti-send"></i>
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default AskPine;
